import { Entity, LiveData } from '@toeverything/infra';

import type { DocRecord, DocsService } from '../../doc';
import type { TemplateDocListStore } from '../store/list';

export class TemplateDocList extends Entity {
  constructor(
    public listStore: TemplateDocListStore,
    public docsService: DocsService
  ) {
    super();
  }

  public isTemplate$(docId: string) {
    return LiveData.from(this.listStore.watchTemplateDoc(docId), false);
  }

  private readonly templateDocProperties$ = LiveData.from(
    this.listStore.watchTemplateDocs(),
    []
  );

  private readonly templateDocIds$ = this.templateDocProperties$.map(
    properties => properties.map(property => property.id)
  );

  /**
   * Pure local projection: DocsService owns availability and access; the
   * template module only intersects that canonical doc map with template IDs.
   */
  public templateDocs$ = LiveData.computed(get => {
    const docsMap = get(this.docsService.list.docsMap$);
    return get(this.templateDocIds$)
      .map(id => docsMap.get(id))
      .filter((doc): doc is DocRecord => !!doc && !get(doc.trash$));
  });
}
